<div class='modal-header d-flex justify-content-between p-2'>
  <h3>Carga masiva</h3>
  <div>
    <button (click)='agregarMailsNuevo()' class='btn btn-primary me-1' [disabled]="cargando"> Agregar</button>
    <button class="btn btn-secondary" [disabled]="cargando" (click)="cancelar()">Volver</button>
  </div>  
</div>
<div class='modal-body aeroplantas'>
  <div class="spinner-container" *ngIf="cargando">
    <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
      type="ball-grid-beat" [fullScreen]="false">
      <p style="color: white"> C a r g a n d o . . . </p>
    </ngx-spinner>
  </div>

  <div *ngIf="cargoAeroplantas">
    <table class="table table-striped table-hover" *ngIf="aeroplantas?.length !== 0 && !cargando">
      <thead>
        <th class='col-3'>Aeroplanta</th>
        <th class='col-6'>Correos asignados</th>
        <th class='col-6'></th>
      </thead>
      <tbody>
        <ng-container *ngFor='let a of aeroplantas; let i = index;'>
          <tr *ngIf="a.correosElectronicos.length > 0">
            <td class='ps-1'>{{ a.nombre }}</td>
            <ng-container *ngIf="aeroplanta !== aeroplantas[i]">
              <td *ngIf="aeroplanta !== aeroplantas[i]" class='ps-1'>{{ a.correosElectronicos.length > 1 ? 'Hay ' +
                a.correosElectronicos.length + ' correos asignados' : a.correosElectronicos[0] }}
              </td>            
              <td class='ps-1 d-flex justify-content-center'>
                <button
                  (click)='setGroup(i)' class='btn btn-primary'>Ver - Agregar - Modificar
                </button>
              </td>
            </ng-container>
            <ng-container *ngIf="aeroplanta === aeroplantas[i]" >
              <td></td>
              <td class='ps-1 d-flex justify-content-center'>
                <button (click)='setGroup(null)' type="button" class="btn-close" aria-label="Close" ngbTooltip="Cerrar modal">
                </button>
              </td>
            </ng-container>            
          </tr>
          <ng-container *ngIf="aeroplanta == aeroplantas[i]">
            <tr *ngFor="let mail of aeroplanta.correosElectronicos; let m = index">
              <td></td>
              <td>{{ mail }}</td>
              <td class='ps-1 d-flex justify-content-center'>
                <button class="btn btn-danger btn-small px-1" ngbTooltip="Quitar mail"
                  (click)="borrarMail(m, i)"><i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <input class="form-control" id="emailFormControl" type="email" class="form-control" placeholder="email@live.com" 
                  [formControl]="emailFormControl" />
                <div *ngIf="email?.invalid && email?.errors?.required && (email.dirty || email.touched)"
                  class="alert alert-danger">El correo electrónico es obligatorio.
                </div>
                <div *ngIf="email?.invalid && email?.errors?.email && (email.dirty || email.touched)"
                  class="alert alert-danger">El correo electrónico no es válido.
                </div>
              </td>
              <td class='ps-1 d-flex justify-content-center'> 
                <button
                  (click)='agregarMail(i)' ngbTooltip="Agregar mail" class="btn btn-small btn-success px-1">
                  <i class="fa fa-plus"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class='ps-1 d-flex justify-content-center'><button (click)="guardarCambios()"
                  class="btn btn-small btn-outline-primary" [disabled]="cargando">Guardar</button></td>
            </tr>
          </ng-container>

        </ng-container>
      </tbody>
    </table>

    <div class="alert alert-warning" *ngIf="this.aeroplantas?.length === 0 && !cargando" class="container">
      No hay emails cargados en el cliente.
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" [disabled]="cargando" (click)="cancelar()">Volver</button>
</div>